import React from 'react';
import '../App.css';
import Header from './Header';

function Manifesto() {
    return (
        <div className="manifesto-page">
            <Header />
            <div className="manifesto-content">
                    <div style={{marginTop: '10vh', width: '70%'}}>
                        <h1>Hiring is broken.</h1>
                        <h1 style={{fontSize: '3rem', color: '#103A0E'}}>
                            Companies and candidates struggle to find the right fit, wasting time, money, and hurting productivity. <span style={{fontWeight: '400'}}>But why?</span>
                        </h1>
                    </div>

                    <p style={{width: '60%', marginTop: '30vh', lineHeight: '1.5', fontWeight: '100', fontSize: '2rem'}}>
                        "From a study conducted with 966 business leaders, 75% reported unsatisfactory hires from this generation."
                    </p>
                    <p style={{width: '60%', lineHeight: '1.5', marginTop: '10px', fontWeight: '100', fontSize: '1rem'}}>
                        Source: Gen Z Hiring Survey, 2024 by Intelligent.com
                    </p>

                    <div style={{marginTop: '30vh', width: '70%'}}>
                        <h1 style={{fontSize: '3rem', color: '#103A0E'}}>
                            Unsuccessful hires stay in the hiring process for too long, draining resources and hurting productivity.
                        </h1>
                        <p style={{width: '100%', lineHeight: '1.5', fontWeight: '100', fontSize: '2rem'}}>
                            "From a study conducted with 966 business leaders, 75% reported unsatisfactory hires from this generation."
                        </p>
                    </div>
            </div>
        </div>
    );
}

export default Manifesto;
